<template>
  <div id="news">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl('/index')">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        活动动态
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <!-- <div class="right" @click="toUrl('/index')">
        <van-icon name="wap-home" size="21" />
      </div> -->
    </div>
    <div class="news-list padding">
      <van-search v-model="value" placeholder="搜索动态..." @input="toSearch()" />
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div
            class="list"
            v-for="(item,index) in news"
            :key="index"
            @click="toInfo(item.id,item.url)"
          >
            <div class="list-tit">{{item.title}}</div>
            <div class="list-time">{{item.create_time}}</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import { Icon, PullRefresh, List, Search } from "vant";
import { article, view } from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Search.name]: Search,
  },
  data() {
    return {
      token: "",
      news: [],
      isLoading: false,
      totalPages: 1,
      padding: false,
      loading: false,
      finished: false,
      page: 0,
      value: "",
    };
  },
  methods: {
    toUrl() {
      // this.$router.push(u);
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
    },
    // 下拉加载
    onLoad() {
      this.getNewsList();
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      // 清空列表数据
      var that = this;
      that.news = [];
      that.page = 0;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getNewsList();
      setTimeout(() => {
        that.refreshing = false;
        // Toast("刷新成功");
        that.isLoading = false;
      }, 1500);
    },
    getNewsList() {
      var that = this;
      var news = this.news;
      var page = this.page + 1;
      var totalPages = this.totalPages;
      var param = {
        page: page,
        pageSize: 10,
        catid: 28,
        keywords: this.value,
      };
      if (totalPages >= page) {
        article(param).then((res) => {
          //////console.log(res);
          if (res.status == 1) {
            if (res.data.data.length < 4) {
              this.padding = false;
            }
            that.page = page;
            that.news = news.concat(res.data.data);
            that.totalPages = Math.ceil(
              Number(res.data.total) / res.data.data.length
            );
            if (res.data.data.length == 0) {
              //数据请求成功 但是无数据
              that.finished = true;
              that.loading = false;
              return false;
            }
            if (that.news.length >= news.length) {
              // 数据请求成功后  停止加载状态
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          } else {
            //登录失败
            // Toast(res.message);
          }
        });
      } else {
        // 全部数据加载完毕
        that.finished = true;
      }
    },
    toInfo(id, url) {
      view({ id: id }).then((res) => {});
      if (url == "") {
        this.$router.push({
          path: "/noticeInfo",
          query: {
            id: id,
            type: 1,
          },
        });
      } else {
        window.location.href = url;
      }
    },
    toSearch() {
      console.log(this.value);
      this.onRefresh();
    },
  },
};
</script>
<style scoped>
.list {
  border-bottom: solid 1px gainsboro;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}
.news-list {
  text-align: left;
  font-size: 0.9rem;
  margin: 0 1rem;
  color: black;
}
.list-time {
  color: #949494;
  font-size: 0.8rem;
  margin-top: 0.3rem;
}
.list-tit {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>


// WEBPACK FOOTER //
// src/page/news.vue